import { HttpInterceptorFn, HttpErrorResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { StateService } from "../../shared/services/state.service";

// Uma recarga de "empresa ativa inválida" por janela: se o 403 persistir mesmo sem empresa salva,
// a tela mostra o erro em vez de recarregar em loop.
const TENANT_RESET_KEY = 'mc_tenant_reset_at';
const TENANT_RESET_WINDOW_MS = 30_000;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const state = inject(StateService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 403) {
        const apiError = error.error?.errors?.[0] || error.error?.Errors?.[0];

        if (apiError?.code === 'User.NotRegistered') {
          window.location.assign(`${window.location.origin}/not-enabled`);
        }

        // Empresa ativa salva no navegador que o usuário perdeu (empresa excluída ou vínculo
        // removido). Até a lista de empresas vai com esse X-Company-Id e toma 403 — o seletor
        // nunca carrega e o usuário fica preso. Esquece a empresa e recarrega: o sessionResolver
        // escolhe uma válida.
        const code = error.error?.Code ?? error.error?.code;
        if (code === 'Tenant.Forbidden' && state.contextAtual) resetTenant(state);
      }

      return throwError(() => error);
    })
  );
};

function resetTenant(state: StateService): void {
  try {
    const last = Number(sessionStorage.getItem(TENANT_RESET_KEY) || 0);
    if (Date.now() - last < TENANT_RESET_WINDOW_MS) return;
    sessionStorage.setItem(TENANT_RESET_KEY, String(Date.now()));
  } catch {
    // sessionStorage indisponível: segue sem a trava (o contexto limpo já evita o loop).
  }
  state.limparContexto();
  window.location.reload();
}
